<div class="card card-nc">
  <div class="card-heading" *ngIf="hasEntitlement('UPLOAD_FORMS')">
    <div class="card-title">UPLOAD FORMS (PDFs only)</div>
  </div>
  <div
    style="padding-top: 30px"
    class="card-body"
    *ngIf="hasEntitlement('UPLOAD_FORMS')"
  >
    <div [ngSwitch]="subview">
      <div *ngSwitchCase="'spinner'">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
      <div *ngSwitchCase="'results'">
        <br />
        Results
        <div>
          <app-forms-view-search
            (newFormUploaded)="onNewFormUploaded()"
            [results]="searchResults"
          ></app-forms-view-search>
        </div>
      </div>
      <div *ngSwitchCase="'formExist'">
        <br />
        <div>
          <app-search-form-exists [results]="searchResults">
          </app-search-form-exists>
        </div>
      </div>
      <div *ngSwitchDefault></div>
    </div>
  </div>
</div>

